"use client";
import { motion } from "framer-motion";
const Opening = () => {
  return (
    <>
      <motion.h2
        className="
      text-3xl sm:text-4xl md:text-5xl lg:text-6xl
      font-extrabold
      text-primary-foreground
      mb-2
      leading-tight
    "
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.5 }}
      >
        Nossa história
      </motion.h2>

      <motion.p
        className="text-lg sm:text-xl md:text-2xl text-primary-foreground/90 mb-2 max-w-3xl mx-auto leading-relaxed"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        Nascida da união entre ciência, mercado e inovação.
      </motion.p>

      <motion.p
        className="text-base sm:text-lg text-gray-500 max-w-4xl mx-auto leading-relaxed mb-10"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        Criada por duas pesquisadoras apaixonadas por transformar o turismo e o
        marketing em experiências únicas, a empresa conecta luxo, tecnologia e
        conhecimento acadêmico para criar projetos que fogem do comum e encantam
        em cada detalhe.
      </motion.p>
    </>
  );
};

export default Opening;
